import Swiper from "swiper";

(function ($) {

    $('.promote-engagement .point').hover(function (e) {
        $('.promote-engagement .point').removeClass('active')
        $('.promote-engagement .image').removeClass('active')
        $('.promote-engagement .image-' + $(this).data('position') + '').addClass('active');
        $(this).addClass('active');
    });

    if($(".engagement-slider.swiper-container").length > 0) {
        const engagement_swiper = new Swiper(".engagement-slider.swiper-container", {
            slidesPerView: 'auto',
            loop: false,
        });
    }

})(jQuery);